var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlotManagment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M322.783 200.348H89.044c-9.22 0-16.696 7.475-16.696 16.696V361.74c0 9.22 7.475 16.696 16.696 16.696h233.739c9.22 0 16.696-7.475 16.696-16.696V217.043c-.001-9.22-7.476-16.695-16.696-16.695zM150.261 345.043h-44.522V233.739h44.522v111.304zm77.913 0h-44.522V233.739h44.522v111.304zm77.913 0h-44.522V233.739h44.522v111.304z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.913 0c-27.618 0-50.087 22.469-50.087 50.087 0 21.766 13.959 40.323 33.391 47.215v136.437h-33.391v-27.826C411.826 92.373 319.455 0 205.913 0 92.373 0 0 92.373 0 205.913v256C0 489.531 22.469 512 50.087 512h311.652c27.618 0 50.087-22.469 50.087-50.087V267.13h50.087c9.22 0 16.696-7.475 16.696-16.696V97.302C498.041 90.41 512 71.853 512 50.087 512 22.469 489.531 0 461.913 0zm-83.478 461.913c0 9.206-7.49 16.696-16.696 16.696H50.087c-9.206 0-16.696-7.49-16.696-16.696v-256c0-95.128 77.393-172.522 172.522-172.522s172.522 77.393 172.522 172.522v256zm83.478-395.13c-9.206 0-16.696-7.49-16.696-16.696s7.49-16.696 16.696-16.696 16.696 7.49 16.696 16.696-7.49 16.696-16.696 16.696z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.103 144.682c-16.521-46.594-60.802-77.9-110.19-77.9-49.389 0-93.67 31.305-110.189 77.9-3.081 8.691 1.467 18.234 10.158 21.315 8.693 3.083 18.234-1.466 21.315-10.156 11.804-33.297 43.438-55.667 78.717-55.667 35.278 0 66.912 22.371 78.718 55.667 2.428 6.846 8.864 11.122 15.736 11.12 1.851 0 3.734-.311 5.58-.964 8.689-3.082 13.237-12.624 10.155-21.315z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.913,
    cy: 150.261,
    r: 16.696,
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.391 411.826H122.435c-9.22 0-16.696 7.475-16.696 16.696s7.475 16.696 16.696 16.696h166.956c9.22 0 16.696-7.475 16.696-16.696s-7.475-16.696-16.696-16.696z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotManagment);
export default __webpack_public_path__ + "static/media/slot-managment.6be46a23b7f4f067ea815cb8021ee0aa.svg";
export { ForwardRef as ReactComponent };